import { ResponseLogin } from 'pages/Login/domain/requestResponses';

export function LoginSuccess(loginData: ResponseLogin) {
  if (loginData.accessToken && loginData.access) {
    localStorage.setItem('token', loginData?.accessToken);
    localStorage.setItem('user', JSON.stringify(loginData.access));
  }
}
